import { globalStyles } from "shared/constants";
const { display, flex } = globalStyles;

const sidebarStyles = {
  drawerPaper: {
    height: "100%",
    width: "180px",
  },
  nameWrapper: {
    padding: "8px",
    marginBottom: "8px",
    backgroundColor: "grey.200",
    ...display.flex,
    ...flex.justify.evenly,
  },
};

export default sidebarStyles;
